/* Copyright (c) 2026 Hyegro Pty Ltd. All rights reserved. */

/** Pure breadcrumb helpers for PageBreadcrumbs (kept import-free for tests). */

/** route path -> display name, from routes.js entries (nested ones too), with app labels applied by route key. */
export function routeNameMap(routes, labels = {}) {
  const map = new Map();
  const walk = (list) =>
    (list || []).forEach((r) => {
      if (r?.route && r?.name && !map.has(r.route)) map.set(r.route, labels[r.key] || r.name);
      if (Array.isArray(r?.collapse)) walk(r.collapse);
    });
  walk(routes);
  return map;
}

function humanise(segment) {
  const text = decodeURIComponent(segment).replace(/[-_]/g, " ");
  return text.charAt(0).toUpperCase() + text.slice(1);
}

/** [{label, to}] for a path; the last crumb has no link. */
export function breadcrumbsFor(pathname, routeNames) {
  const parts = pathname.split("/").filter(Boolean);
  const crumbs = parts.map((part, i) => {
    const to = `/${parts.slice(0, i + 1).join("/")}`;
    const label = routeNames.get(to) || (/^\d+$/.test(part) ? `#${part}` : humanise(part));
    return { label, to: routeNames.has(to) ? to : null };
  });
  if (crumbs.length) crumbs[crumbs.length - 1].to = null;
  return crumbs;
}
